module.exports = __webpack_public_path__ + "static/img/9.6c2b065.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/zh/9.png
// module id = NPhU
// module chunks = 0